import { type VariantProps, cva } from "class-variance-authority";
import { X } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

const closeButtonVariants = cva(
  "inline-flex items-center justify-center transition-color transition-opacity rounded-sm p-0 opacity-70 ring-offset-background hover:bg-inherit hover:opacity-100 hover:text-accent-foregrounds focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus-visible:outline-none disabled:opacity-50 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none",
  {
    variants: {
      variant: {
        default: "",
        toast:
          "rounded-md p-1 text-foreground/50 opacity-0 hover:text-foreground focus:opacity-100 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      },
      size: {
        default: "h-fit",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof closeButtonVariants> {}

const CloseButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, onClick, ...props }, ref) => {
    return (
      <button
        type="button"
        className={cn(closeButtonVariants({ variant, size, className }))}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <X className="h-4 w-4" />
        <span className="sr-only">Close</span>
      </button>
    );
  },
);
CloseButton.displayName = "CloseButton";

export { CloseButton, closeButtonVariants };
